import { FC, ReactNode } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface CarouselProps {
  children: ReactNode;
  slidesToShowMobile: number;
  slidesToShowTab?: number;
  slidesToShowDesktop?: number;
}

const Carousel: FC<CarouselProps> = ({
  children,
  slidesToShowMobile,
  slidesToShowTab,
  slidesToShowDesktop,
}) => {
  const settings = {
    // className: 'center',
    centerMode: false,
    arrow: true,
    dots: false,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: slidesToShowDesktop,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowTab,
          infinite: true,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: slidesToShowMobile,
          initialSlide: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: slidesToShowMobile,
          centerMode: false,
          arrows: true,
        },
      },
    ],
  };

  return <Slider {...settings}>{children}</Slider>;
};

export default Carousel;
